/*
 * Supports importing modules with a subpath pattern "submodule:url#module"
 */
import { systemJSPrototype } from '../system-core';

/**
 * Gets the submodule resolved URL if submodule: syntax has been applied
 */
 export function getSubmoduleResolved(resolved) {
  if (resolved.startsWith("submodule:")) {
    return resolved.substring(10).split("#");
  }
  return [resolved, null];
}

function getSubModule(member, sub, main) {
  if (sub) {
    var paths = sub.split('/');
    for (var p of paths) {
      var formattedMember = p.replace(/[-\\]/g, '_');
      if (member[p] || member[formattedMember]) {
        member = member[p] || member[formattedMember];
      } else {
        throw Error(`submodule not found: (${sub} in ${main})`);
      }
    }
    if (typeof member === "function") {
      member = member();
    }
  }
  return member;
}

var systemInstantiate = systemJSPrototype.instantiate;

systemJSPrototype.instantiate = function instantiate(url, parent) {
  if (url.startsWith('submodule:')) {

    var [mainModule, submodule] = getSubmoduleResolved(url);

    QlikSystem.register([mainModule], function(_export) {
      var containerBundleModule;
      return {
        setters: [
          function(module) {
            containerBundleModule = module;
          },
        ],
        execute: function() {
          if (!containerBundleModule) {
            return Promise.reject(new Error(`submodule (${submodule}) dependency (${mainModule}) could not be loaded, it might be because of a circular dependency`))
          }
          var member = getSubModule(containerBundleModule, submodule, mainModule);
          return Promise.resolve(member).then(function(sub) {
            if (!sub) {
              return Promise.reject(
                new Error(
                  `mainmodule found, but returns undefined: ${submodule} in ${mainModule}`
                )
              );
            }
            _export(sub);
            if (!sub.default) {
              _export("default", sub);
            }
          });
        },
      };
    });
    return Promise.resolve(this.getRegister(url));
  }
  return systemInstantiate.call(this, url, parent);
};
